import { PaginationInput, PaginationResponse } from '@repo/ui/data-table'

import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterGroups(centerId: number, input?: PaginationInput) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterGroups.url, { id: centerId }), input)
    )
    .get<PaginationResponse<CenterGroup>>()
}
